export const CREATE_INDEX = 'CREATE_INDEX';
export const RESET_PERSONA = 'RESET_PERSONA';
export const CREATE_PIVOT = 'CREATE_PIVOT';
export const FILE_UPLOAD = 'FILE_UPLOAD';
export const GET_AUDIENCE = 'GET_AUDIENCE';
export const GET_COLUMN = 'GET_COLUMN';
export const GET_MAPVIEW = 'GET_MAPVIEW';
export const GET_MOBILITY_DATES = 'GET_MOBILITY_DATES';
export const GET_REGIONS = 'GET_REGIONS';
export const GET_REPORT = 'GET_REPORT';
export const GET_STORE_NAME = 'GET_STORE_NAME';
export const GET_TABLE = 'GET_TABLE';
export const GET_TOKEN = 'GET_TOKEN';
export const GET_VALUE = 'GET_VALUE';
export const HANDLE_ERROR = 'HANDLE_ERROR';
export const HANDLE_PERMISSION_ERROR = 'HANDLE_PERMISSION_ERROR';
export const LOADING = 'LOADING';
export const LOADING_COMPLETE = 'LOADING_COMPLETE';
export const LOADING_DECREMENT = 'LOADING_DECREMENT';
export const LOADING_INCREMENT = 'LOADING_INCREMENT';
export const PIVOT_COLUMNS = 'PIVOT_COLUMNS';
export const PIVOT_REFRESH = 'PIVOT_REFRESH';
export const REFRESH = 'REFRESH';
export const REFRESH_AUDIENCE = 'REFRESH_AUDIENCE';
export const CLEAR_MAIN = 'CLEAR_MAIN';
export const REPORT_REFRESH = 'REPORT_REFRESH';
export const SAVE_REPORT = 'SAVE_REPORT';
export const SET_AUDIENCE_SIZE = 'SET_AUDIENCE_SIZE';
export const SET_IDS = 'SET_IDS';
export const SET_PERSISTENT_DATASET = 'SET_PERSISTENT_DATASET';
export const SET_NON_PERSISTENT_DATASET = 'SET_NON_PERSISTENT_DATASET';
export const SET_MAPCOND = 'SET_MAPCOND';
export const SET_PROGRESS = 'SET_PROGRESS';
export const USER_GROUPS = 'USER_GROUPS';
export const SET_DEFINECUS = 'SET_DEFINECUS';
export const SET_CRM_LIST = 'SET_CRM_LIST';
export const SET_EXECUTIVE_MMM_DATA = 'SET_EXECUTIVE_MMM_DATA';
export const SET_ACTIVE_MODEL = 'SET_ACTIVE_MODEL';
export const SET_ACTIVE_ADMIN_MODEL = 'SET_ACTIVE_ADMIN_MODEL';
export const RESET_STATE = 'RESET_STATE';
export const RESET_OMM_STATE = 'RESET_OMM_STATE';
export const SET_MODEL_DATES = 'SET_MODEL_DATES';
export const SET_FORECAST_MODEL_DATES = 'SET_FORECAST_MODEL_DATES';
export const SET_END_DATE_AND_INDEX = 'SET_END_DATE_AND_INDEX';
export const SET_FORECAST_END_DATE = 'SET_FORECAST_END_DATE';
export const SET_START_DATE_AND_INDEX = 'SET_START_DATE_AND_INDEX';
export const SET_MEDIA = 'SET_MEDIA';
export const SET_MIN_MAX_MEDIA = 'SET_MIN_MAX_MEDIA';
export const SET_CHOOSEN_MEDIA_RANGE = 'SET_CHOOSEN_MEDIA_RANGE';
export const SET_ROAS_PROJECTIONS_MMM_DATA = 'SET_ROAS_PROJECTIONS_MMM_DATA';
export const SET_ADSTOCK_IMPACT = 'SET_ADSTOCK_IMPACT';
export const SET_OMM_DATA = 'SET_OMM_DATA';
export const SET_OMM_GRAPH_DATA = 'SET_OMM_GRAPH_DATA';
export const SET_GROUPING_VALUE = 'SET_GROUPING_VALUE';
export const SET_TOGGLES_TARGETS = 'SET_TOGGLES_TARGETS';
export const SET_FEATURES = 'SET_FEATURES';
export const SET_TITLE = 'SET_TITLE';
export const SET_MMM_DATA_AFTER_TOGGLE_UPDATE =
  'SET_MMM_DATA_AFTER_TOGGLE_UPDATE';
export const SET_COMPARED_MEDIA = 'SET_COMPARED_MEDIA';
export const SET_FORECAST_RANGE = 'SET_FORECAST_RANGE';
export const SET_PROMOTION_SLIDER_INFO = 'SET_PROMOTION_SLIDER_INFO';
export const SET_MEDIA_ENTITIES = 'SET_MEDIA_ENTITIES';
export const SET_METRIC = 'SET_METRIC';
export const SET_MODEL_BUILD_DATE = 'SET_MODEL_BUILD_DATE';
export const SET_CATEGORIES = 'SET_CATEGORIES';
export const SET_SELECTED_CATEGORIES = 'SET_SELECTED_CATEGORIES';
export const SET_EXCHANGE_RATES = 'SET_EXCHANGE_RATES';
export const SET_CURRENCY = 'SET_CURRENCY';
export const SET_PREFIX_SYMBOLS = 'SET_PREFIX_SYMBOLS';
export const SET_VERSION = 'SET_VERSION';
export const SET_SPECIFIC_PROGRESS = 'SET_SPECIFIC_PROGRESS';
export const SET_ACTIVE_CRM_KEY = 'SET_ACTIVE_CRM_KEY';
export const SET_SYNERGY = 'SET_SYNERGY';
export const SET_ACTIVE_CRM_HEADER = 'SET_ACTIVE_CRM_HEADER';
export const SET_ACTIVE_CRM_DATA = 'SET_ACTIVE_CRM_DATA';
export const SET_CRM_STATE_TO_INITIAL = 'SET_CRM_STATE_TO_INITIAL';
export const SET_CRM_LOOKALIKE = 'SET_CRM_LOOKALIKE';
export const SET_CRM_AUDIENCE_SIZE = 'SET_CRM_AUDIENCE_SIZE';
export const SET_CRM = 'SET_CRM';
export const SET_CRM_DATASET = 'SET_CRM_DATASET';
export const RESET_IDS = 'RESET_IDS';
export const RESET_ERROR = 'RESET_ERROR';
export const RESET_CRM_ID = 'RESET_CRM_ID';
export const SAVE_CRM_DATA = 'SAVE_CRM_DATA';
export const SET_CRM_HEADERS = 'SET_CRM_HEADERS';
export const SET_NICKNAME = 'SET_NICKNAME';
export const SET_LOADING_LABEL = 'SET_LOADING_LABEL';
export const SET_CRM_TEMPLATE_USE = 'SET_CRM_TEMPLATE_USE';
export const SET_WORKFLOW_ID = 'SET_WORKFLOW_ID';
export const SET_WORKFLOW_COMPLETE = 'SET_WORKFLOW_COMPLETE';
export const SET_EXPORT_INTEGRATIONS = 'SET_EXPORT_INTEGRATIONS';
